import _ from 'lodash';

import { OrderPreferenceIdEnum } from 'Common/Constants/Enumeration/OrderPreferenceEnum';
import { ItemEnum, SiteGroupEnum, SiteEnum } from 'Common/FieldEnum';

import * as types from './types';

const INITIAL_STATE = {
  //get all sites
  allSitesData: [],
  loadingAllSites: false,
  allSitesLoadingError: null,

  //submit Entities
  isSubmitting: false,
  submitted: false,
  submitError: null,

  //get site group
  siteGroupData: [],
  loadingSiteGroup: false,
  siteGroupLoadingError: null,

  //get all items
  allItemsData: [],
  loadingAllItems: false,
  allItemsLoadingError: null,

  loadingAllUsers: false,
  allUsersLoadingError: null,
  allUsersData: [],

  //get storage location
  storageLocationByIdLoadingError: null,
  loadingStorageByIdLocation: false,
  loadingStorageLocationById: false,

  sitesByItemId: [],
  itemsBySiteId: [],
  siteGroupsByItemId: [],
  itemsBySiteGroupId: [],
  sitesByUserName: [],
  siteGroupsByUserName: [],
  usersBySiteGroupId: [],
  usersBySiteId: [],

  assignedStorageLocationData: null,
  submitSuccessMsg: '',
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    //get price details
    case types.ASSIGN_ENTITIES_GET_ALL_SITES_LOADING:
      return {
        ...state,
        loadingAllSites: action.payload,
      };

    case types.ASSIGN_ENTITIES_ALL_SITES_DATA:
      const allSitesData = action.payload.map(site => {
        site[SiteEnum.OrderPreferenceName] =
          OrderPreferenceIdEnum[site[SiteEnum.OrderPreferenceId]];
        site[SiteEnum.MinimumParLevel] = '';
        site[SiteEnum.MaximumParLevel] = '';
        site[SiteEnum.CheckBox] = false;
        return site;
      });
      return {
        ...state,
        allSitesData,
      };

    case types.ASSIGN_ENTITIES_GET_ALL_SITES_LOADING_ERROR:
      return {
        ...state,
        allSitesLoadingError: action.payload,
      };

    case types.ASSIGN_ENTITIES_ITEMS_GRID_UPDATE:
      return {
        ...state,
      };

    case types.ASSIGN_ENTITIES_SITE_GROUP_LOADING:
      return {
        ...state,
        loadingSiteGroup: action.payload,
      };

    case types.ASSIGN_ENTITIES_SITE_GROUP_DATA:
      const siteGroupData = _.cloneDeep(action.payload);
      siteGroupData.forEach(siteGroup => {
        siteGroup[SiteEnum.MinimumParLevel] = null;
        siteGroup[SiteEnum.MaximumParLevel] = null;
        siteGroup[SiteGroupEnum.SiteModel].forEach(site => {
          site[SiteEnum.OrderPreferenceName] =
            OrderPreferenceIdEnum[site[SiteEnum.OrderPreferenceId]];
        });
      });
      return {
        ...state,
        siteGroupData,
      };

    case types.ASSIGN_ENTITIES_SITE_GROUP_LOADING_ERROR:
      return {
        ...state,
        siteGroupLoadingError: action.payload,
      };

    //get all items
    case types.ASSIGN_ENTITIES_GET_ITEMS_LOADING:
      return {
        ...state,
        loadingAllItems: action.payload,
      };

    case types.ASSIGN_ENTITIES_GET_ITEMS_DATA:
      // let data = _.cloneDeep(action.payload);
      const data = action.payload.map(item => {
        item[ItemEnum.StorageLocationIds] = item[ItemEnum.StorageLocationIds]
          ? item[ItemEnum.StorageLocationIds].split(',')
          : '';
        return item;
      });
      return {
        ...state,
        allItemsData: data,
      };

    case types.ASSIGN_ENTITIES_GET_ITEMS_LOADING_ERROR:
      return {
        ...state,
        allItemsLoadingError: action.payload,
      };

    case types.RE_ORDER_ITEM_LIST:
      return {
        ...state,
        allItemsData: action.payload,
      };

    case types.RE_ORDER_SITES_LIST:
      return {
        ...state,
        allSitesData: action.payload,
      };

    case types.RE_ORDER_USERS_LIST:
      return {
        ...state,
        allUsersData: action.payload,
      };

    case types.ASSIGN_ENTITIES_GET_USERS_LOADING:
      return {
        ...state,
        loadingAllUsers: action.payload,
      };

    case types.ASSIGN_ENTITIES_GET_USERS_DATA:
      return {
        ...state,
        allUsersData: action.payload,
      };

    case types.ASSIGN_ENTITIES_GET_USERS_LOADING_ERROR:
      return {
        ...state,
        allUsersLoadingError: action.payload,
      };

    case types.ASSIGN_ENTITIES_CLEAR_USER_DATA:
      return {
        ...state,
        allUsersLoadingError: null,
        allUsersData: [],
      };

    case types.SUBMITTING_ASSIGN_ENTITIES:
      return {
        ...state,
        isSubmitting: action.payload,
      };

    case types.SUBMITTED_ASSIGN_ENTITIES:
      if (_.has(action.payload, 'data')) {
        const submitResponse = action.payload.data;
        if (
          _.has(submitResponse, 'Data.Message') &&
          submitResponse.Data.Message
        ) {
          return {
            ...state,
            submitted: true,
            submitSuccessMsg: submitResponse.Data.Message,
          };
        }
      }
      return {
        ...state,
        submitSuccessMsg: 'Assigned Successfully',
        submitted: true,
      };

    case types.SUBMITTING_ASSIGN_ENTITIES_ERROR:
      return {
        ...state,
        submitError: action.payload,
      };

    case types.CLEAR_SUBMIT_ERROR:
      return {
        ...state,
        submitError: null,
        allUsersLoadingError: null,
        allItemsLoadingError: null,
        siteGroupLoadingError: null,
        allSitesLoadingError: null,
        submitted: false,
      };

    //get storage location
    case types.GET_STORAGE_LOCATION_LOADING:
      return {
        ...state,
        loadingStorageLocationById: action.payload,
      };

    case types.GET_STORAGE_LOCATION_LOADING_ERROR:
      return {
        ...state,
        storageLocationByIdLoadingError: action.payload,
      };

    case types.CLEAR_STORAGE_LOCATION_LOADING_ERROR:
      return {
        ...state,
        storageLocationByIdLoadingError: null,
      };

    case types.RE_ORDER_SITE_GROUPS:
      return {
        ...state,
        siteGroupData: action.payload,
      };

    case types.RE_ORDER_SITES:
      return {
        ...state,
        allSitesData: action.payload,
      };

    case types.SET_SITES_BY_ITEM_ID:
      return {
        ...state,
        sitesByItemId: action.payload,
      };

    case types.SET_ITEMS_BY_SITE_ID:
      return {
        ...state,
        itemsBySiteId: action.payload,
      };

    case types.SET_SITE_GROUPS_BY_ITEM_ID:
      return {
        ...state,
        siteGroupsByItemId: action.payload,
      };

    case types.SET_ITEMS_BY_SITE_GROUP_ID:
      return {
        ...state,
        itemsBySiteGroupId: action.payload,
      };

    case types.SET_SITES_BY_USER_NAME:
      return {
        ...state,
        sitesByUserName: action.payload,
      };

    case types.SET_SITE_GROUPS_BY_USER_NAME:
      return {
        ...state,
        siteGroupsByUserName: action.payload,
      };

    case types.SET_USERS_BY_SITE_GROUP_ID:
      return {
        ...state,
        usersBySiteGroupId: action.payload,
      };

    case types.SET_USERS_BY_SITE_ID:
      return {
        ...state,
        usersBySiteId: action.payload,
      };

    case types.SET_STORAGE_LOCATION_ASSIGNED_DATA:
      return {
        ...state,
        assignedStorageLocationData: action.payload,
      };

    default:
      return { ...state };
  }
};



// WEBPACK FOOTER //
// ./src/pages/utilities/state/assignEntities/reducer.js